export enum UserSetsActionTypes {
  FETCH_REQUEST = 'user-sets/FETCH_REQUEST',
  FETCH_SUCCESS = 'user-sets/FETCH_SUCCESS',
  FETCH_ERROR = 'user-sets/FETCH_ERROR',
}
